// extracted by mini-css-extract-plugin
export default {"link":"ApplicationsMobileTable_link__+RQFF","chatIcon":"ApplicationsMobileTable_chatIcon__K6nO2","table":"ApplicationsMobileTable_table__ZfTK6"};